import { useState } from "react";
import { Typography } from "@/components/atoms";
import { useLayout, useOperator, useProfile } from "@/hooks";
import { clsx } from "@/utils";
import { SidebarNavItem } from "./SidebarNavItem";
import { getMenuNavigation, getMoreNavigation } from "./helpers";

interface SidebarNavProps {
  ignoreSidebarOpen?: boolean;
}

export const SidebarNav = ({ ignoreSidebarOpen }: SidebarNavProps) => {
  const { id: operatorId, roles, joined } = useOperator();
  const { id: userId } = useProfile();
  const {
    layout: { sidebarOpen: isOpen },
  } = useLayout();
  const sidebarOpen = ignoreSidebarOpen ? true : isOpen;
  const headerClassName = clsx("text-neutral-silver-gray", {
    "text-center": !sidebarOpen,
  });
  const isAdmin = roles.includes("Fa_Access") || roles.includes("Owner") || roles.includes("Admin");
  const [showHelpNotification] = useState(false);

  const renderDriverMenu = () => {
    const navItem = {
      name: "My Profile",
      to: `/driver/${userId}/profile/`,
      icon: "User",
    };

    if (roles.includes("Driver")) {
      return (
        <div className="flex flex-col gap-y-3">
          <Typography variant="action" className={headerClassName}>
            Driver Menu
          </Typography>
          <div className="flex flex-col">
            <SidebarNavItem key={navItem.name} item={navItem} sidebarOpen={sidebarOpen} />
          </div>
        </div>
      );
    }
  };

  const renderClientMenu = () => {
    const navItem = {
      name: "My Bookings",
      to: `/passenger/${userId}/booking/history`,
      icon: "ArchiveBook",
    };

    if (roles.includes("Passenger")) {
      return (
        <div className="flex flex-col gap-y-3">
          <Typography variant="action" className={headerClassName}>
            Client Menu
          </Typography>
          <div className="flex flex-col">
            <SidebarNavItem key={navItem.name} item={navItem} sidebarOpen={sidebarOpen} />
          </div>
        </div>
      );
    }
  };

  return (
    <nav className="no-scrollbar flex flex-col overflow-auto border-none px-5">
      {renderDriverMenu()}
      {renderClientMenu()}
      <div className="mb-5 flex flex-col gap-y-3">
        <Typography variant="action" className={headerClassName}>
          Menu
        </Typography>
        <div className="flex flex-col">
          {getMenuNavigation(operatorId, joined)
            .filter((item) => !item.adminOnly || isAdmin)
            .map((item) => (
              <SidebarNavItem key={item.name} item={item} sidebarOpen={sidebarOpen} />
            ))}
        </div>
      </div>
      <div className="flex flex-col gap-y-3">
        <Typography variant="action" className={headerClassName}>
          Others
        </Typography>
        <div className="flex flex-col">
          {getMoreNavigation()
            .filter((item) => !item.adminOnly || isAdmin)
            .map((item) => (
              <SidebarNavItem
                key={item.name}
                item={item}
                sidebarOpen={sidebarOpen}
                showNotification={item.name === "Help" && showHelpNotification}
              />
            ))}
        </div>
      </div>
    </nav>
  );
};
